import {
  convertDesignIdToCommunicationId,
  convertTaskListGroupToElementDesignId,
} from 'src/app/lego-utils';
import { Area, IViolation, TaskListHeader } from 'src/app/models';

export abstract class TechnicalSpecificationFormatValidation {
  public static validate(taskList: TaskListHeader[], isDuplo = false): IViolation[] {
    // For a DUPLO element the prefix must be "Master Duplo"; for a regular element it must be
    // "Master" without the "Duplo" (a regular Master TS mistakenly prefixed "Master Duplo" is a
    // violation), so the two cases need different guidance.
    const prefixRequirement = isDuplo
      ? 'must start with "Master Duplo"'
      : 'must start with "Master" and not "Master Duplo"';

    return taskList
      .map((task) => ({
        task,
        malformed: !TechnicalSpecificationFormatValidation.getRegEx(task).test(task.description),
        wrongPrefix: TechnicalSpecificationFormatValidation.hasWrongPrefix(
          task.description,
          isDuplo
        ),
      }))
      .filter(({ malformed, wrongPrefix }) => malformed || wrongPrefix)
      .map(({ task, malformed }) => ({
        // A malformed description takes priority; otherwise it is a Master TS with the wrong prefix.
        message: malformed
          ? `${task.taskListGroup} description (${task.description}) is malformed`
          : `${task.taskListGroup} description (${task.description}) ${prefixRequirement}`,
        pathToViolation: [
          { area: Area.Specifications },
          {
            area: Area.TechnicalSpecification,
            displayId: `${task.taskListGroup}-${task.groupCounter}`,
            id: task.id,
          },
        ],
      }));
  }

  // The prefix check applies only to Master TSs (identified by a leading "Master"). The prefix must
  // match the element type: a DUPLO element must start with "Master Duplo", and a regular element
  // must start with "Master" but not "Master Duplo".
  private static hasWrongPrefix(description: string, isDuplo: boolean): boolean {
    if (!description.startsWith('Master')) {
      return false;
    }

    return isDuplo
      ? !description.startsWith('Master Duplo')
      : description.startsWith('Master Duplo');
  }

  private static getRegEx(taskListHeader: TaskListHeader) {
    const designId = convertTaskListGroupToElementDesignId(taskListHeader.taskListGroup);
    const communicationId = convertDesignIdToCommunicationId(designId);
    const zeroPaddedCommunicationId = communicationId.padStart(5, '0');

    return new RegExp(`TS[A0]${zeroPaddedCommunicationId}-[0-9]{3}\/V[0-9]{2}\/[A-Z]$`, 'u');
  }
}
